<template>
  <div class="search-container">
    <el-form ref="form" inline>
      <el-form-item label="单号" label-width="80px">
        <el-input v-model="queryParam.orderNo" clearable></el-input>
      </el-form-item>
      <el-form-item label="服务商" label-width="80px" v-if="$permission.hasAuth([4, 8, 14, 6, 7, 10, 11])">
        <el-select v-model="queryParam.agentSn" clearable filterable remote :remote-method="getAgents" :loading="loading" placeholder="输入服务商名称搜索">
          <el-option v-for="agent in agents" :key="agent.sn" :label="agent.companyName" :value="agent.sn"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="140px" v-if="$permission.hasAuth([4, 8, 14, 10, 11])">
        <template #label>
          <el-select v-model="shopType" @change="queryParam.directFactorySn = ''" style="width: 126px;">
            <el-option v-for="(item, index) in shopTypes" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </template>
        <template #default>
          <el-select v-model="queryParam.directFactorySn" v-if="shopType === 'direct'" clearable filterable placeholder="请选择门店">
            <el-option v-for="item in shops" :key="item.sn" :label="item.companyName" :value="item.sn"></el-option>
          </el-select>
          <el-select v-model="queryParam.directFactorySn" v-if="shopType === 'online'" clearable filterable placeholder="请选择门店">
            <el-option v-for="item in onlineShops" :key="item.sn" :label="item.companyName" :value="item.sn"></el-option>
          </el-select>
          <el-select v-model="queryParam.directFactorySn" v-if="shopType === 'xue'" clearable filterable placeholder="请选择门店">
            <el-option v-for="item in xueShops" :key="item.sn" :label="item.companyName" :value="item.sn"></el-option>
          </el-select>
        </template>
      </el-form-item>
      <el-form-item label="类型" label-width="80px" v-if="typeVisible">
        <el-select v-model="queryParam.type" clearable>
          <el-option v-for="(item, index) in orderTypes" :key="index" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" label-width="80px">
      <el-input v-model="queryParam.memo" clearable></el-input>
    </el-form-item>
      <el-form-item label="状态" label-width="80px">
        <el-checkbox v-model="statusAll" :indeterminate="indeterminate" @change="handleCheckAllChange">所有</el-checkbox>
        <el-checkbox-group v-model="queryParam.statuses" @change="handleCheckedStatusesChange">
          <el-checkbox :label="1" v-if="!$permission.hasAuth([7])">待确认</el-checkbox>
          <el-checkbox :label="4" v-if="!$permission.hasAuth([7])">待审核</el-checkbox>
          <el-checkbox :label="2">待出库</el-checkbox>
          <el-checkbox :label="3">完成</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button type="primary" @click="list(1)">
          <el-icon><search /></el-icon>查询
        </el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="10">
          <div class="table-title"><span></span>补货单列表</div>
        </el-col>
        <el-col :span="14">
          <div class="table-button-container">
            <!--
            <el-button type="primary" v-if="$permission.hasAuth([4, 8, 10, 11]) || currentUser.directAgent" @click="exportData()">
              导出直营数据
            </el-button>
            -->
            <el-button type="primary" @click="showExport()">
              下载
            </el-button>
            <el-button type="primary" v-if="0 && $permission.hasAuth([4, 8, 14, 7, 10, 11])" @click="mergeOrder()">
              合并补货单
            </el-button>
            <el-button type="primary" v-if="$permission.hasAuth([4, 8, 14, 7, 10, 11])" @click="showQueryQuantity()">
              查询补货量
            </el-button>
            <el-button type="success" v-if="$permission.hasAuth([4, 8, 14, 7, 10, 11]) || currentUser.directAgent" @click="showDetail(null, 'newDirect')">
              <el-icon><plus /></el-icon>直营店补货
            </el-button>
            <el-button type="success" v-if="$permission.hasAuth([4, 8, 14, 7])" @click="showDetail(null, 'newXue')">
              <el-icon><plus /></el-icon>薛老师认证店补货
            </el-button>
            <el-button type="success" v-if="$permission.hasAuth([4, 8, 14, 10, 11, 1])" @click="showDetail(null, 'newAgent')">
              <el-icon><plus /></el-icon>服务商补货
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="orders" @selection-change="handleSelectionChange" border>
      <el-table-column v-if="0 && $permission.hasAuth([4, 8, 14, 7, 10, 11])" type="selection" :selectable="handleSelectable"></el-table-column>
      <el-table-column prop="orderDate" label="时间"></el-table-column>
      <el-table-column prop="orderNo" label="单号"></el-table-column>
      <el-table-column label="类型">
        <template #default="scope">
          {{scope.row.type === 0 ? '服务商首单' : scope.row.type === 1 ? '门店首单补货' : scope.row.type === 2 ? '门店30箱补货'
            : scope.row.type === 3 ? '直营门店补货' : scope.row.type === 4 ? '门店首单和换油30箱补货' : scope.row.type === 5 ? '线上门店补货'
                : scope.row.type === 6 ? '薛老师认证店补货' : scope.row.type === 7 ? '线下支付订购' : '未知'}}
          <el-popover v-if="scope.row.factoryNames && scope.row.factoryNames.length > 0" placement="top-start" title="门店" :width="280" trigger="hover"
              :content="scope.row.factoryNames.join()"
          >
            <template #reference>
              <el-link type="primary" href="javascript:;">门店</el-link>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="油量">
        <template #default="scope">
          <span :class="scope.row.status !== 3 && scope.row.oilNum >= 30 ? 'color_danger font_size_28' : ''">{{scope.row.oilNum}}</span>{{scope.row.unit}}
        </template>
      </el-table-column>
      <el-table-column label="金额">
        <template #default="scope">
          ￥{{scope.row.amount}}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="140">
        <template #default="scope">
          <div style="margin: 6px 0;">
            {{scope.row.status === 1 ? '待确认' : scope.row.status === 4 ? '待审核' : scope.row.status === 2 ? '待出库' : scope.row.status === 3 ? '完成' : '未知'}}
            <!--
            <el-badge :is-dot="!scope.row.logisticsPic">
              <el-button @click="showLogistics(scope.row)">物流单</el-button>
            </el-badge>
            <span>&nbsp;&nbsp;</span>
            -->
            <el-button v-if="scope.row.payedPic" @click="showPayedPic(scope.row.payedPic)">转账单</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="recCompanyName" label="公司名称"></el-table-column>
      <el-table-column label="收货信息">
        <template #default="scope">
          <div>收货人：{{scope.row.recName}}</div>
          <div>收货电话：{{scope.row.recPhone}}</div>
          <div>收货地址：{{scope.row.recProvinceName + (scope.row.recCityName !== scope.row.recProvinceName ? scope.row.recCityName : '') + scope.row.recCountyName + scope.row.recAddress}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="memo" label="备注"></el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-link type="primary" href="javascript:;" @click="showDetail(scope.row)">详情</el-link>
          <el-dropdown>
            <span class="cursor_pointer color_normal">
              操作<el-icon><arrow-down/></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-if="$permission.hasAuth([4, 8, 14, 10, 11, 1]) && scope.row.status === 1" @click="showDetail(scope.row, 'confirm')">确认补货</el-dropdown-item>
                <el-dropdown-item v-if="$permission.hasAuth([4, 8, 14, 6, 10, 11]) && scope.row.status !== 1" @click="showAudit(scope.row)">{{scope.row.status === 4 ? '审核' : '修改备注'}}</el-dropdown-item>
                <el-dropdown-item v-if="$permission.hasAuth([4])" @click="showDetail(scope.row, 'edit')">修改</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.payedPic" @click="showPayedPic(scope.row.payedPic)">转账单</el-dropdown-item>
                <el-dropdown-item @click="showOtherPic(scope.row)">附件</el-dropdown-item>
                <el-dropdown-item @click="showLogistics(scope.row)">物流信息</el-dropdown-item>
                <el-dropdown-item v-if="$permission.hasAuth([4, 8, 6, 7, 10, 11]) && scope.row.status === 2" @click="showDetail(scope.row, 'out')">出库</el-dropdown-item>
                <!--
                <el-dropdown-item v-if="$permission.hasAuth([4, 8, 14]) && scope.row.type === 7" @click="mergeAgentOrder(scope.row)">合并换油</el-dropdown-item>
                -->
                <el-dropdown-item v-if="$permission.hasAuth([4, 14]) && scope.row.status !== 2 && scope.row.status !== 3" @click="deleteOrder(scope.row)">删除</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.status === 3" @click="download(scope.row.excelInfo)">下载明细</el-dropdown-item>
                <el-dropdown-item v-if="$permission.hasAuth([4, 8, 7]) && scope.row.vendorOrderExcelInfo" @click="download(scope.row.vendorOrderExcelInfo)">下载采购单</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                   :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </div>

  <el-dialog title="详情" v-model="printVisible" custom-class="dialog_width_large"
             :close-on-click-modal="false" :close-on-press-escape="false">
    <div id="print" style="font-size: 14px;font-weight: normal;">
      <div style="padding: 16px 0;">
        <div style="line-height: 46px;text-align: center;font-size: 22px;font-weight: bold;">补货单</div>
        <table style="border-collapse: collapse;border-spacing: 0;width: 100%;line-height: 36px;text-align: center;">
          <tr>
            <th style="border: 1px solid #EBEEF5;">公司名称</th>
            <td style="border: 1px solid #EBEEF5;" colspan="6">{{order.recCompanyName}}</td>
          </tr>
          <tr>
            <th style="border: 1px solid #EBEEF5;">单号</th>
            <td style="border: 1px solid #EBEEF5;" colspan="3">{{order.orderNo}}</td>
            <th style="border: 1px solid #EBEEF5;">时间</th>
            <td style="border: 1px solid #EBEEF5;" colspan="2">{{order.orderDate}}</td>
          </tr>
          <tr>
            <th style="border: 1px solid #EBEEF5;">收货人</th>
            <td style="border: 1px solid #EBEEF5;">{{order.recName}}</td>
            <th style="border: 1px solid #EBEEF5;">收货电话</th>
            <td style="border: 1px solid #EBEEF5;">{{order.recPhone}}</td>
            <th style="border: 1px solid #EBEEF5;">收货地址</th>
            <td style="border: 1px solid #EBEEF5;" colspan="2">{{order.recProvinceName + (order.recCityName !== order.recProvinceName ? order.recCityName : '') + order.recCountyName + order.recAddress}}</td>
          </tr>
          <tr>
            <th style="border: 1px solid #EBEEF5;">序号</th>
            <th style="border: 1px solid #EBEEF5;" colspan="3">名称</th>
            <th style="border: 1px solid #EBEEF5;">价格</th>
            <th style="border: 1px solid #EBEEF5;">数量</th>
            <th style="border: 1px solid #EBEEF5;">金额</th>
          </tr>
          <tr v-for="(item, index) in order.goodsSupplementOrderItemVOS" :key="index">
            <td style="border: 1px solid #EBEEF5;">{{index + 1}}</td>
            <td style="border: 1px solid #EBEEF5;" colspan="3">{{item.name}}</td>
            <td style="border: 1px solid #EBEEF5;">￥{{item.price}}</td>
            <td style="border: 1px solid #EBEEF5;">{{item.quantity}}{{item.unit}}</td>
            <td style="border: 1px solid #EBEEF5;">￥{{item.amount}}</td>
          </tr>
          <tr>
            <td style="border: 1px solid #EBEEF5;text-align: right;" colspan="6">合计：</td>
            <td style="border: 1px solid #EBEEF5;">￥{{order.amount}}</td>
          </tr>
        </table>
      </div>
    </div>
    <el-button type="primary" v-print="'#print'" @click="print" style="margin-top: 12px;">打印</el-button>
  </el-dialog>

  <el-dialog :title="'confirm' === type || 'newDirect' === type || 'newXue' === type || 'newAgent' === type ? '确认补货' : 'out' === type ? '出库' : 'edit' === type ? '修改' : '详情'"
             v-model="detailVisible" custom-class="dialog_width_large" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form v-if="type && ('out' !== type)" label-width="98px" style="text-align: left;">
      <el-form-item label="类型" v-if="type === 'newAgent' && $permission.hasAuth([4, 8, 14, 10, 11])">
        <el-select v-model="order.type">
          <el-option label="服务商首单" :value="0"></el-option>
          <!--
          <el-option label="门店首单补货" :value="1"></el-option>
          <el-option label="门店30箱补货" :value="2"></el-option>
          -->
          <el-option label="线下支付订购" :value="7"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务商" v-if="type === 'newAgent' && $permission.hasAuth([4, 8, 14, 10, 11])">
        <el-select v-model="order.sn" filterable remote :remote-method="getAgents2" :loading="loading2" placeholder="输入服务商名称搜索">
          <el-option v-for="agent in agents2" :key="agent.sn" :label="agent.companyName" :value="agent.sn"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="直营门店" v-if="type === 'newDirect'">
        <el-select v-model="order.factorySn" filterable placeholder="请选择门店">
          <el-option v-for="item in shops" :key="item.sn" :label="item.companyName" :value="item.sn"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="薛老师认证店" v-if="type === 'newXue'">
        <el-select v-model="order.factorySn" filterable placeholder="请选择门店">
          <el-option v-for="item in xueShops" :key="item.sn" :label="item.companyName" :value="item.sn"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="运费" v-if="type === 'newDirect' || type === 'newXue'">
        <el-select v-model="order.deliverFee" filterable placeholder="请选择运费">
          <el-option label="到付自提" value="到付自提"></el-option>
          <el-option label="现付送货" value="现付送货"></el-option>
          <el-option label="快递" value="快递"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="收货人" v-if="type !== 'newAgent' && type !== 'newDirect' && type !== 'newXue'">
        <el-input v-model="order.recName"></el-input>
      </el-form-item>
      <el-form-item label="收货电话" v-if="type !== 'newAgent' && type !== 'newDirect' && type !== 'newXue'">
        <el-input v-model="order.recPhone"></el-input>
      </el-form-item>
      <el-form-item label="收货地址" v-if="type !== 'newAgent' && type !== 'newDirect' && type !== 'newXue'">
        <el-cascader ref="location" v-model="location" :props="locations" @change="locationChangeHandler" style="display: inline-block;width: 28%;"></el-cascader>
        <el-input v-model="order.recAddress" style="display: inline-block;width: 72%;"></el-input>
      </el-form-item>
      <el-form-item label="转账单" v-if="type === 'newDirect' || type === 'newXue' || type === 'newAgent'">
        <el-upload class="image_uploader" :action="apiBase + 'api/v1/common/upload/image/agent_payed'" :show-file-list="false"
                   :on-success="function(res,file){return handleSuccess(res,file, null)}" :before-upload="beforeUpload">
          <img v-if="order.payedPic" :src="$utils.imageSrc(order.payedPic)"/>
          <el-icon v-else class="uploader_icon"><plus /></el-icon>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="table-header" v-if="type === 'confirm' || type === 'edit' || type === 'newDirect' || type === 'newXue' || type === 'newAgent'">
      <div class="table-button-container">
        <el-select v-model="oil" value-key="sn" placeholder="请选择油品">
          <el-option v-for="oil in oils" :key="oil.sn" :label="oil.name" :value="oil"></el-option>
        </el-select>
        <el-button type="primary" @click="addDetail()">添加油品</el-button>
      </div>
    </div>
    <el-table :data="order.goodsSupplementOrderItemVOS" border>
      <el-table-column type="index" label="序号"></el-table-column>
      <!--
      <el-table-column label="图片">
        <template #default="scope">
          <img :src="$utils.imageSrc(scope.row.pic)"/>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column label="类型">
        <template #default="scope">
          {{scope.row.type === 0 ? '油品' : '物料'}}
        </template>
      </el-table-column>
      <el-table-column label="价格" v-if="!$permission.hasAuth([4, 8, 6]) || (type !== 'confirm' && type !== 'edit' && type !== 'newDirect' && type !== 'newXue' && type !== 'newAgent')">
        <template #default="scope">
          ￥{{scope.row.price}}
        </template>
      </el-table-column>
      <el-table-column label="数量" v-if="type !== 'confirm' && type !== 'edit' && type !== 'newDirect' && type !== 'newXue' && type !== 'newAgent'">
        <template #default="scope">
          {{scope.row.quantity + scope.row.unit}}
        </template>
      </el-table-column>
      <el-table-column label="价格" v-if="$permission.hasAuth([4, 8, 6]) && (type === 'confirm' || type === 'edit' || type === 'newDirect' || type === 'newXue' || type === 'newAgent')">
        <template #default="scope">
          <el-input type="number" v-model="scope.row.price" :readonly="scope.row.type !== 0" @change="countOrderAmount" placeholder="请输入价格">
            <template #append>元</template>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column label="数量" v-if="type === 'confirm' || type === 'edit' || type === 'newDirect' || type === 'newXue' || type === 'newAgent'">
        <template #default="scope">
          <el-input type="number" v-model="scope.row.quantity" :readonly="scope.row.type !== 0" @change="countOrderAmount" placeholder="请输入数量">
            <template #append>{{scope.row.unit}}</template>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column label="供应商" v-if="0 && 'out' === type">
        <template #default="scope">
          <el-select v-model="scope.row.vendorSn">
            <el-option v-for="item in suppliers" :key="item.sn" :label="item.companyName" :value="item.sn"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="操作" v-if="type === 'confirm' || type === 'edit' || type === 'newDirect' || type === 'newXue' || type === 'newAgent'">
        <template #default="scope">
          <el-link type="danger" href="javascript:;" v-if="scope.row.type === 0" @click="deleteDetail(scope.$index)">删除</el-link>
        </template>
      </el-table-column>
      <template v-slot:append>
        <div style="padding-right: 12px; line-height: 32px; text-align: right; font-size: 15px;">合计：<span class="color_danger">￥{{order.amount}}</span></div>
      </template>
    </el-table>
    <el-button type="primary" v-if="'confirm' === type || type === 'newDirect' || type === 'newXue' || type === 'newAgent'" @click="confirmOrder" style="margin-top: 12px;">确认补货</el-button>
    <el-button type="primary" v-if="'out' === type" @click="confirmOut" style="margin-top: 12px;">确认出库</el-button>
    <el-button type="primary" v-if="'edit' === type" @click="confirmEdit" style="margin-top: 12px;">确认</el-button>
  </el-dialog>

  <el-dialog :title="order.status === 4 ? '审核' : '修改备注'" v-model="auditVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form ref="sendForm">
      <el-form-item label="转账单" label-width="88px" v-if="order.status === 4">
        <el-upload class="image_uploader" :action="apiBase + 'api/v1/common/upload/image/agent_payed'" :show-file-list="false"
                   :on-success="function(res,file){return handleSuccess(res,file, null)}" :before-upload="beforeUpload">
          <img v-if="order.payedPic" :src="$utils.imageSrc(order.payedPic)"/>
          <el-icon v-else class="uploader_icon"><plus /></el-icon>
        </el-upload>
      </el-form-item>
      <el-form-item label="备注" label-width="88px">
        <el-input type="text" v-model="order.memo"></el-input>
      </el-form-item>
      <el-button type="primary" @click="audit">确认</el-button>
    </el-form>
  </el-dialog>

  <el-dialog title="其他附件" v-model="otherPicVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-upload v-if="$permission.hasAuth([4, 8, 6, 7, 10, 11])" :action="apiBase + 'api/v1/common/upload/image/other'" :show-file-list="false"
               :on-success="function(res,file){return handleSuccess(res,file,'other')}" :before-upload="beforeUpload">
      <el-button>上传附件</el-button>
    </el-upload>
    <div class="image_list" v-for="(item, index) in otherPic" :key="index">
      <el-icon class="delete_btn" v-if="$permission.hasAuth([4, 8, 6, 7, 10, 11])" @click="handleRemove(index, 'other')"><delete /></el-icon>
      <el-image :src="$utils.imageSrc(item)" :preview-src-list="[$utils.imageSrc(item)]" fit="cover"></el-image>
    </div>
  </el-dialog>

  <el-dialog title="物流信息" v-model="logisticsVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-upload v-if="$permission.hasAuth([4, 8, 6, 7, 10, 11])" :action="apiBase + 'api/v1/common/upload/image/logistics'" :show-file-list="false"
               :on-success="function(res,file){return handleSuccess(res,file,'logistics')}" :before-upload="beforeUpload">
      <el-button>上传物流信息</el-button>
    </el-upload>
    <div class="image_list" v-for="(item, index) in logistics" :key="index">
      <el-icon class="delete_btn" v-if="$permission.hasAuth([4, 8, 6, 7, 10, 11])" @click="handleRemove(index, 'logistics')"><delete /></el-icon>
      <el-image :src="$utils.imageSrc(item)" :preview-src-list="[$utils.imageSrc(item)]" fit="cover"></el-image>
    </div>
  </el-dialog>

  <el-dialog title="查询补货数量" v-model="queryVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form inline style="text-align: left;">
      <el-form-item label="服务商" label-width="88px">
        <el-select v-model="queryAgentSn" filterable remote :remote-method="getAgents3" :loading="loading3" clearable placeholder="输入服务商名称搜索">
          <el-option v-for="agent in agents3" :key="agent.sn" :label="agent.companyName" :value="agent.sn"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button type="primary" @click="confirmQuery">
          <el-icon><search /></el-icon>查询
        </el-button>
      </el-form-item>
    </el-form>
    <div v-if="queryDetail">
      <div>{{queryDetail.memo}}</div>
      <el-table :data="queryDetail.details" border>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column label="箱数">
          <template #default="scope">
            {{scope.row.box}}箱
          </template>
        </el-table-column>
        <el-table-column label="升数">
          <template #default="scope">
            {{scope.row.amount}}升
          </template>
        </el-table-column>
      </el-table>
      <el-button type="primary" v-if="queryDetail.box >= 3" @click="generateOrder">生成补货单</el-button>
    </div>
  </el-dialog>

  <el-dialog title="下载" v-model="exportVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form>
      <el-form-item label="时间" label-width="80px">
        <el-date-picker
            v-model="dateRange"
            type="daterange"
            value-format="YYYY-MM-DD"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="截止时间"
        >
        </el-date-picker>
        <div class="tips color_danger">注：最长可选择3个月</div>
      </el-form-item>
      <el-button type="primary" @click="exportData">确认</el-button>
    </el-form>
  </el-dialog>

  <el-image-viewer v-if="showViewer" @close="showViewer = false" :url-list="viewerUrls" />
</template>

<script>
export default {
  name: "服务商补货单",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      apiBase: process.env.VUE_APP_API_BASE,
      pageSizes: [10, 20, 50],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      orderTypes: [],
      queryParam: {
        statuses: [1, 2, 3, 4, 5]
      },
      typeVisible: true,
      loading: false,
      agents: [],
      statusAll: true,
      indeterminate: false,
      orders: [],
      printVisible: false,
      detailVisible: false,
      order: {},
      type: null,
      locations: {},
      location: null,
      suppliers: [],
      shopType: 'direct',
      shopTypes: [{name: '直营门店', value: 'direct'}, {name: '线上门店', value: 'online'}, {name: '薛老师认证店', value: 'xue'}],
      shops: [],
      onlineShops: [],
      xueShops: [],
      loading2: false,
      agents2: [],
      auditVisible: false,
      checkedOrders: [],
      oils: [],
      oil: null,
      otherPicVisible: false,
      otherPic: [],
      logisticsVisible: false,
      logistics: [],
      orderNo: null,
      loading3: false,
      agents3: [],
      queryVisible: false,
      queryAgentSn: null,
      queryDetail: null,
      exportVisible: false,
      dateRange: [],
      showViewer: false,
      viewerUrls: []
    }
  },
  methods: {
    beforeUpload(file) {
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLes5M = file.size / 1024 / 1024 < 5
      if (!isImg) {
        this.$message.error('图片只能是 JPG 格式!')
      }
      if (!isLes5M) {
        this.$message.error('图片大小不能超过 5MB!')
      }
      return isImg && isLes5M
    },
    handleSuccess(res, file, type) {
      if (!type) {
        this.order.payedPic = res.data
      } else if (type === 'other') {
        let pics = [res.data].concat(this.otherPic)
        let param = {
          goodsSupplementOrderNo: this.orderNo,
          pic: pics.length > 1 ? pics.join() : pics.length === 1 ? pics[0] : null
        }
        this.$apis.store.saveAgentTodoOtherPic(param).then(response => {
          if (response.status === 200) {
            this.getOtherPic()
          }
        })
      } else if (type === 'logistics') {
        let pics = [res.data].concat(this.logistics)
        let param = {
          goodsSupplementOrderNo: this.orderNo,
          pic: pics.length > 1 ? pics.join() : pics.length === 1 ? pics[0] : null
        }
        this.$apis.store.saveAgentTodoLogistics(param).then(response => {
          if (response.status === 200) {
            this.getLogistics()
          }
        })
      }
    },
    handleRemove(index, type) {
      console.log(index)
      if (type === 'other') {
        this.otherPic.splice(index, 1)
        let param = {
          goodsSupplementOrderNo: this.orderNo,
          pic: this.otherPic.length > 1 ? this.otherPic.join() : this.otherPic.length === 1 ? this.otherPic[0] : ''
        }
        this.$apis.store.saveAgentTodoOtherPic(param).then(response => {
          if (response.status === 200) {
            this.getOtherPic()
          }
        })
      } else {
        this.logistics.splice(index, 1)
        let param = {
          goodsSupplementOrderNo: this.orderNo,
          pic: this.logistics.length > 1 ? this.logistics.join() : this.logistics.length === 1 ? this.logistics[0] : ''
        }
        this.$apis.store.saveAgentTodoLogistics(param).then(response => {
          if (response.status === 200) {
            this.getLogistics()
          }
        })
      }
    },
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      this.$utils.deleteEmptyProperty(this.queryParam)
      this.$apis.store.agentTodoList(this.pageIndex - 1, this.pageSize, this.queryParam).then(response => {
        let orders = response.data.data
        orders.forEach(item => {
          item.oilNum = item.goodsSupplementOrderItemVOS.filter(subItem => subItem.type === 0).reduce((total, subItem) => total + subItem.quantity, 0)
          const oil = item.goodsSupplementOrderItemVOS.find(subItem => subItem.type === 0)
          item.unit = oil ? oil.unit : ''
        })
        this.orders = orders
        this.total = response.data.total
      })
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.list()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.list(1)
    },
    showDetail(order, type) {
      this.type = type
      if (!type) {
        this.printVisible = true;
        this.order = JSON.parse(JSON.stringify(order));
      } else if (type === 'newDirect' || type === 'newXue' || type === 'newAgent') {
        this.detailVisible = true
        this.order = {
          goodsSupplementOrderItemVOS: []
        }
        // 服务商只能创建类型为7的补货单
        if (this.currentUser.type === 1) {
          this.order.sn = this.currentUser.sn
          this.order.type = 7
        }
        this.$apis.storeGoods.list(0, 99, {}).then(response => {
          this.oils = response.data.data
        })
      } else {
        this.detailVisible = true
        this.order = JSON.parse(JSON.stringify(order))
        this.location = [order.recProvinceCode, order.recCityCode, order.recCountyCode]
        this.$apis.storeGoods.list(0, 99, {type: 0}).then(response => {
          this.oils = response.data.data
        })
      }
      this.countOrderAmount();
    },
    addDetail() {
      if (!this.oil) {
        this.$message.error('请选择油品')
        return
      }
      if (this.order.goodsSupplementOrderItemVOS.findIndex(item => item.goodsSn === this.oil.sn) >= 0) {
        this.$message.error('油品已存在')
        return
      }
      this.order.goodsSupplementOrderItemVOS.push({
        goodsSn: this.oil.sn,
        pic: this.oil.pic,
        name: this.oil.name,
        type: this.oil.type,
        quantity: 1,
        unit: this.oil.baseUnit,
        price: 0
      })
      this.countOrderAmount();
    },
    deleteDetail(index) {
      this.order.goodsSupplementOrderItemVOS.splice(index, 1);
      this.countOrderAmount();
    },
    countOrderAmount() {
      this.order.amount = this.order.goodsSupplementOrderItemVOS.reduce((total, item) => total + item.price * 100 * item.quantity, 0) / 100;
    },
    confirmOrder() {
      if (this.type === 'newAgent' && (!this.order.type && this.order.type !== 0)) {
        this.$message.error('请选择类型')
        return
      }
      if (this.type === 'newAgent' && !this.order.sn) {
        this.$message.error('请选择服务商')
        return
      }
      if ((this.type === 'newDirect' || this.type === 'newXue') && !this.order.factorySn) {
        this.$message.error('请选择门店')
        return
      }
      if ((this.type === 'newDirect' || this.type === 'newXue') && !this.order.deliverFee) {
        this.$message.error('请选择运费')
        return
      }
      if ((this.type === 'newDirect' || this.type === 'newXue' || this.type === 'newAgent') && !this.order.payedPic) {
        this.$message.error('请上传转账单')
        return
      }
      if (this.type === 'confirm' && !this.order.recName) {
        this.$message.error('请输入收货人')
        return
      }
      if (this.type === 'confirm' && !this.order.recPhone) {
        this.$message.error('请输入收货电话')
        return
      }
      if (this.type === 'confirm' && (!this.order.recProvinceCode || !this.order.recCityCode || !this.order.recCountyCode || !this.order.recAddress)) {
        this.$message.error('请输入收货地址')
        return
      }
      if (this.order.goodsSupplementOrderItemVOS.length <= 0) {
        this.$message.error('请选择油品')
        return
      }
      if (!this.order.goodsSupplementOrderItemVOS.every(item => item.quantity != null)) {
        this.$message.error('请输入数量')
        return
      }
      if (this.type === 'confirm' && this.order.goodsSupplementOrderItemVOS.filter(item => item.type === 0).reduce((total, item) => total + Number(item.quantity), 0) !== this.order.oilNum) {
        this.$message.error('油品总数量必须为' + this.order.oilNum)
        return
      }
      if (this.type === 'newDirect') {
        let param = {
          factorySn: this.order.factorySn,
          deliverFee: this.order.deliverFee,
          payedPic: this.order.payedPic,
          goodsItemTOS: []
        }
        this.order.goodsSupplementOrderItemVOS.forEach(item => {
          param.goodsItemTOS.push({
            goodsSn: item.goodsSn,
            quantity: item.quantity,
            price: item.price
          })
        })
        this.$apis.store.newDirectlyOrder(param).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.detailVisible = false
            this.list()
          }
        })
      } else if (this.type === 'newXue') {
        let param = {
          factorySn: this.order.factorySn,
          deliverFee: this.order.deliverFee,
          payedPic: this.order.payedPic,
          goodsItemTOS: []
        }
        this.order.goodsSupplementOrderItemVOS.forEach(item => {
          param.goodsItemTOS.push({
            goodsSn: item.goodsSn,
            quantity: item.quantity,
            price: item.price
          })
        })
        this.$apis.store.newXueOrder(param).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.detailVisible = false
            this.list()
          }
        })
      } else if (this.type === 'newAgent') {
        let param = {
          sn: this.order.sn,
          type: this.order.type,
          payedPic: this.order.payedPic,
          goodsSupplementOrderItemTOS: []
        }
        this.order.goodsSupplementOrderItemVOS.forEach(item => {
          param.goodsSupplementOrderItemTOS.push({
            goodsSn: item.goodsSn,
            quantity: item.quantity,
            name: item.name,
            unit: item.unit,
            price: item.price
          })
        })
        this.$apis.store.newAgentOrder(param).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.detailVisible = false
            this.list()
          }
        })
      } else {
        let param = {
          orderNo: this.order.orderNo,
          goodsSupplementItemTOS: [],
          recLogisticsInfo: {
            recName: this.order.recName,
            recPhone: this.order.recPhone,
            recProvinceCode: this.order.recProvinceCode,
            recProvinceName: this.order.recProvinceName,
            recCityCode: this.order.recCityCode,
            recCityName: this.order.recCityName,
            recCountyCode: this.order.recCountyCode,
            recCountyName: this.order.recCountyName,
            recAddress: this.order.recAddress
          }
        }
        this.order.goodsSupplementOrderItemVOS.filter(item => item.type === 0).forEach(item => {
          param.goodsSupplementItemTOS.push({
            goodsSn: item.goodsSn,
            quantity: item.quantity,
            price: item.price
          })
        })
        this.$apis.store.agentTodoConfirm(param).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.detailVisible = false
            this.list()
          }
        })
      }
    },
    confirmOut() {
      /*if (!this.order.goodsSupplementOrderItemVOS.every(item => item.vendorSn != null)) {
        this.$message.error('请选择供应商')
        return
      }*/
      let param = {
        agentSn: this.order.agentSn,
        orderNo: this.order.orderNo,
        vendorExportItemTOS: []
      }
      this.order.goodsSupplementOrderItemVOS.forEach(item => {
        param.vendorExportItemTOS.push({
          goodsSn: item.goodsSn,
          name: item.name,
          pic: item.pic,
          quantity: item.quantity,
          unit: item.unit,
          type: item.type,
          vendorSn: item.vendorSn
        })
      })
      this.$apis.store.agentTodoOut(param).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '出库成功',
            type: 'success'
          })
          this.detailVisible = false
          this.list()
        }
      })
    },
    confirmEdit() {
      if (!this.order.recName) {
        this.$message.error('请输入收货人')
        return
      }
      if (!this.order.recPhone) {
        this.$message.error('请输入收货电话')
        return
      }
      if (!this.order.recProvinceCode || !this.order.recCityCode || !this.order.recCountyCode || !this.order.recAddress) {
        this.$message.error('请输入收货地址')
        return
      }
      if (!this.order.goodsSupplementOrderItemVOS.every(item => item.quantity != null)) {
        this.$message.error('请输入数量')
        return
      }
      if (this.order.goodsSupplementOrderItemVOS.filter(item => item.type === 0).reduce((total, item) => total + Number(item.quantity), 0) !== this.order.oilNum) {
        this.$message.error('油品总数量必须为' + this.order.oilNum)
        return
      }
      let param = {
        orderNo: this.order.orderNo,
        goodsSupplementItemTOS: [],
        recLogisticsInfo: {
          recName: this.order.recName,
          recPhone: this.order.recPhone,
          recProvinceCode: this.order.recProvinceCode,
          recProvinceName: this.order.recProvinceName,
          recCityCode: this.order.recCityCode,
          recCityName: this.order.recCityName,
          recCountyCode: this.order.recCountyCode,
          recCountyName: this.order.recCountyName,
          recAddress: this.order.recAddress
        }
      }
      this.order.goodsSupplementOrderItemVOS.filter(item => item.type === 0).forEach(item => {
        param.goodsSupplementItemTOS.push({
          goodsSn: item.goodsSn,
          quantity: item.quantity,
          price: item.price
        })
      })
      this.$apis.store.agentTodoEdit(param).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.detailVisible = false
          this.list()
        }
      })
    },
    showAudit(order) {
      this.auditVisible = true
      this.order = {
        goodsSupplementOrderSn: order.sn,
        memo: order.memo,
        status: order.status
      }
    },
    audit() {
      if (this.order.status === 4 && !this.order.payedPic) {
        this.$message.error('请上传转账单')
        return
      }
      if (this.order.status === 4) {
        this.$apis.store.auditAgentTodo(this.order).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '审核成功',
              type: 'success'
            })
            this.auditVisible = false
            this.list()
          }
        })
      } else {
        this.$apis.store.memoAgentTodo(this.order).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.auditVisible = false
            this.list()
          }
        })
      }
    },
    mergeOrder() {
      if (this.checkedOrders.length <= 1) {
        this.$message.error('请至少选择两个补货单')
        return
      }
      if (this.checkedOrders.reduce((types, item) => {
        if (!types.includes(item.type)) {
          types.push(item.type)
        }
        return types
      }, []).length > 1) {
        this.$message.error('只能选择同类型的补货单')
        return
      }
      if (this.checkedOrders.reduce((agentSns, item) => {
        if (!agentSns.includes(item.agentSn)) {
          agentSns.push(item.agentSn)
        }
        return agentSns
      }, []).length > 1) {
        this.$message.error('只能选择同服务商的补货单')
        return
      }
      this.$apis.store.mergeAgentTodo(this.checkedOrders.map(item => item.orderNo)).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '合并成功',
            type: 'success'
          })
          this.checkedOrders = []
          this.list()
        }
      })
    },
    download(url) {
      setTimeout(() => {
        window.open(url)
      }, 1500)
    },
    showExport() {
      this.exportVisible = true
    },
    exportData() {
      if (!this.dateRange || !this.dateRange.length) {
        this.$message.error('请选择时间')
        return
      }
      const from = new Date(this.dateRange[0]), to = new Date(this.dateRange[1])
      if (from.getFullYear() !== to.getFullYear()) {
        this.$message.error('时间不能跨年份')
        return
      }
      const duration = this.$utils.dateCompare(from, to)
      if (duration[0] || duration[1] > 3 || (duration[1] === 3 && duration[2])) {
        this.$message.error('时间不能超过3个月')
        return
      }
      const param = {...this.queryParam, ...{downloadStartDate: this.dateRange[0], downloadEndDate: this.dateRange[1]}}
      this.$apis.store.downloadOrderData(param).then(response => {
        if (response.status === 200) {
          setTimeout(() => {
            window.open(response.data)
          }, 1500)
        }
      })
    },
    handleSelectionChange(val) {
      this.checkedOrders = val
    },
    handleSelectable(row, index) {
      return row.status === 2
    },
    handleCheckAllChange(value) {
      this.indeterminate = false
      this.queryParam.statuses = value ? [1, 2, 3, 4, 5] : []
    },
    handleCheckedStatusesChange(value) {
      const count = value.length
      this.statusAll = count === 5
      this.indeterminate = count > 0 && count < 5
    },
    showOtherPic(order) {
      this.otherPicVisible = true
      this.orderNo = order.orderNo
      this.otherPic = []
      this.getOtherPic()
    },
    getOtherPic() {
      this.$apis.store.agentTodoOtherPic(this.orderNo).then(response => {
        this.otherPic = response.data ? response.data.split(',') : []
      })
    },
    showLogistics(order) {
      this.logisticsVisible = true
      this.orderNo = order.orderNo
      this.logistics = []
      this.getLogistics()
    },
    getLogistics() {
      this.$apis.store.agentTodoLogistics(this.orderNo).then(response => {
        this.logistics = response.data ? response.data.split(',') : []
      })
    },
    mergeAgentOrder(order) {
      this.$confirm(
          '确认合并该服务商的换油补货单？',
          '合并',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(() => {
        this.$apis.store.mergeAgentOrder(order.sn).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '合并成功',
              type: 'success'
            })
            this.list()
          }
        })
      })
    },
    deleteOrder(order) {
      this.$confirm(
          '确认删除该补货单？',
          '删除',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(() => {
        this.$apis.store.deleteAgentOrder(order.sn).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.list()
          }
        })
      })
    },
    showQueryQuantity() {
      this.queryVisible = true
    },
    confirmQuery() {
      if (!this.queryAgentSn) {
        this.$message.error('请选择服务商')
        return
      }
      this.$apis.store.queryAgentQuantity(this.queryAgentSn).then(response => {
        this.queryDetail = response.data
      })
    },
    generateOrder() {
      if (!this.queryAgentSn) {
        this.$message.error('请选择服务商')
        return
      }
      this.$apis.store.generateAgentOrder(this.queryAgentSn).then(response => {
        if (response.status === 200) {
          this.queryVisible = false
          this.list(1)
        }
      })
    },
    showPayedPic(url) {
      this.viewerUrls = [this.$utils.imageSrc(url)]
      this.showViewer = true
    },
    locationChangeHandler() {
      const node = this.$refs['location'].getCheckedNodes()
      this.order.recProvinceCode = node[0].pathValues[0]
      this.order.recProvinceName = node[0].pathLabels[0]
      this.order.recCityCode = node[0].pathValues[1]
      this.order.recCityName = node[0].pathLabels[1]
      this.order.recCountyCode = node[0].pathValues[2]
      this.order.recCountyName = node[0].pathLabels[2]
    },
    locationLazyLoad(node, resolve) {
      let _that = this
      if (node.level === 0) {
        _that.$apis.common.provinces().then(response => {
          const provinces = response.data
          let nodes = []
          provinces.forEach(item => {
            nodes.push({
              value: item.code,
              label: item.name,
              leaf: false
            })
          })
          resolve(nodes)
        })
      } else if (node.level === 1) {
        _that.$apis.common.cities(node.value).then(response => {
          const cities = response.data
          let nodes = []
          cities.forEach(item => {
            nodes.push({
              value: item.code,
              label: item.name,
              leaf: false
            })
          })
          resolve(nodes)
        })
      } else {
        _that.$apis.common.counties(node.value).then(response => {
          const counties = response.data
          let nodes = []
          counties.forEach(item => {
            nodes.push({
              value: item.code,
              label: item.name,
              leaf: true
            })
          })
          resolve(nodes)
        })
      }
    },
    getAgents(str) {
      if (str !== '') {
        this.loading = true
        this.$apis.agentMgr.list(0, 15, {companyName: str}).then(response => {
          this.agents = response.data.data
          this.loading = false
        })
      } else {
        this.agents = []
      }
    },
    getAgents2(str) {
      if (str !== '') {
        this.loading2 = true
        this.$apis.agentMgr.list(0, 15, {companyName: str}).then(response => {
          this.agents2 = response.data.data
          this.loading2 = false
        })
      } else {
        this.agents2 = []
      }
    },
    getAgents3(str) {
      if (str !== '') {
        this.loading3 = true
        this.$apis.agentMgr.list(0, 15, {companyName: str}).then(response => {
          this.agents3 = response.data.data
          this.loading3 = false
        })
      } else {
        this.agents3 = []
      }
    }
  },
  created() {
    this.orderTypes = [
      {
        name: '服务商首单',
        value: 0
      }, {
        name: '门店首单补货',
        value: 1
      }, {
        name: '门店30箱补货',
        value: 2
      }, {
        name: '直营门店补货',
        value: 3
      }, {
        name: '门店首单和换油30箱补货',
        value: 4
      }, {
        name: '线上门店补货',
        value: 5
      }, {
        name: '薛老师认证店补货',
        value: 6
      }, {
        name: '线下支付订购',
        value: 7
      }
    ]
    if (this.currentUser.type === 1) {
      this.orderTypes = this.orderTypes.filter(item => item.value !== 3 && item.value !== 5 && item.value !== 6)
      this.queryParam.agentSn = this.currentUser.sn
    } else {
      if (this.currentUser.type === 6) {
        this.typeVisible = false
        this.queryParam.type = 0
      } else if (this.currentUser.type === 7) {
        this.queryParam.statuses = [0, 2, 3]
      } else if (this.currentUser.type === 10) {
        this.queryParam.generalServiceSn = this.currentUser.sn
      }
      this.$apis.shopMgr.directlyShops().then(response => {
        this.shops = response.data
      })
      this.$apis.shopMgr.onlineShops().then(response => {
        this.onlineShops = response.data
      })
      this.$apis.shopMgr.xueShops().then(response => {
        this.xueShops = response.data
      })
    }
    this.list()
    this.$apis.storeSupplier.list(0, 99, {}).then(response => {
      this.suppliers = response.data.data
    })
    this.locations = {
      lazy: true,
      lazyLoad: this.locationLazyLoad
    }
  }
}
</script>

<style scoped>
.image_list {
  position: relative;
  display: inline-block;
  width: 120px;
  height: 120px;
  margin: 6px 6px 0 0;
}
.image_list .delete_btn {
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 100;
  font-size: 18px;
  cursor: pointer;
}
.image_list .delete_btn:hover {
  color: #409EFF;
}
.font_size_28 {
  font-size: 28px;
}
</style>